import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "render", "context", "classes", "variables", "style", "className", "children"],
    _excluded2 = ["container", "track", "photo"];
import "core-js/modules/es.object.from-entries.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, createElement } from "react";
import { clsx, cssClass, cssVar, round, srcSetAndSizes, unwrap } from "../utils/index.js";

function Component(_ref, ref) {
  var as = _ref.as,
      render = _ref.render,
      context = _ref.context,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? [] : _ref$classes,
      _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? {} : _ref$variables,
      styleProp = _ref.style,
      classNameProp = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = clsx.apply(void 0, _toConsumableArray((Array.isArray(classes) ? classes : [classes]).filter(function (el) {
    return typeof el === "string";
  }).map(cssClass)).concat([classNameProp]));

  var style = _objectSpread(_objectSpread({}, Object.fromEntries(Object.entries(variables).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return [cssVar(key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()), typeof value === "number" ? round(value, 5) : value];
  }))), styleProp);

  var props = _objectSpread({
    style: style,
    className: className,
    children: children
  }, rest);

  if (render) {
    var rendered = render(_objectSpread({
      ref: ref
    }, props), context);
    if (rendered) return rendered;
  }

  var Element = as || "div";
  return jsx(Element, _objectSpread({
    ref: ref
  }, props));
}

var Component$1 = forwardRef(Component);

function PhotoComponent(_ref4, ref) {
  var photo = _ref4.photo,
      index = _ref4.index,
      width = _ref4.width,
      height = _ref4.height,
      onClick = _ref4.onClick,
      _ref4$render = _ref4.render;
  _ref4$render = _ref4$render === void 0 ? {} : _ref4$render;
  var wrapper = _ref4$render.wrapper,
      link = _ref4$render.link,
      button = _ref4$render.button,
      image = _ref4$render.image,
      extras = _ref4$render.extras,
      _ref4$componentsProps = _ref4.componentsProps;
  _ref4$componentsProps = _ref4$componentsProps === void 0 ? {} : _ref4$componentsProps;
  var linkProps = _ref4$componentsProps.link,
      buttonProps = _ref4$componentsProps.button,
      wrapperProps = _ref4$componentsProps.wrapper,
      imageProps = _ref4$componentsProps.image;
  var src = photo.src,
      alt = photo.alt,
      title = photo.title,
      href = photo.href;
  var context = {
    photo: photo,
    index: index,
    width: round(width, 3),
    height: round(height, 3)
  };
  var props;

  if (href) {
    props = _objectSpread(_objectSpread({}, linkProps), {}, {
      as: "a",
      render: link,
      classes: ["photo", "link"],
      href: href,
      onClick: onClick
    });
  } else if (onClick) {
    props = _objectSpread(_objectSpread({}, buttonProps), {}, {
      as: "button",
      type: "button",
      render: button,
      classes: ["photo", "button"],
      onClick: onClick
    });
  } else {
    props = _objectSpread(_objectSpread({}, wrapperProps), {}, {
      render: wrapper,
      classes: "photo"
    });
  }

  return jsxs(Component$1, _objectSpread(_objectSpread({
    ref: ref,
    variables: {
      photoWidth: context.width,
      photoHeight: context.height
    }
  }, _objectSpread({
    context: context
  }, props)), {}, {
    children: [jsx(Component$1, _objectSpread({
      as: "img",
      classes: "image",
      render: image
    }, _objectSpread({
      src: src,
      alt: alt,
      title: title,
      context: context
    }, imageProps))), extras === null || extras === void 0 ? void 0 : extras({}, context)]
  }));
}

var PhotoComponent$1 = forwardRef(PhotoComponent);

function StaticPhotoAlbum(_ref5, ref) {
  var layout = _ref5.layout,
      sizes = _ref5.sizes,
      model = _ref5.model,
      skeleton = _ref5.skeleton,
      onClickCallback = _ref5.onClick,
      _ref5$render = _ref5.render;
  _ref5$render = _ref5$render === void 0 ? {} : _ref5$render;

  var container = _ref5$render.container,
      track = _ref5$render.track,
      renderPhoto = _ref5$render.photo,
      restRender = _objectWithoutProperties(_ref5$render, _excluded2),
      _ref5$componentsProps = _ref5.componentsProps;

  _ref5$componentsProps = _ref5$componentsProps === void 0 ? {} : _ref5$componentsProps;
  var containerProps = _ref5$componentsProps.container,
      trackProps = _ref5$componentsProps.track,
      linkProps = _ref5$componentsProps.link,
      buttonProps = _ref5$componentsProps.button,
      wrapperProps = _ref5$componentsProps.wrapper,
      imageProps = _ref5$componentsProps.image;

  var _ref6 = model || {},
      spacing = _ref6.spacing,
      padding = _ref6.padding,
      containerWidth = _ref6.containerWidth,
      tracks = _ref6.tracks,
      variables = _ref6.variables,
      horizontal = _ref6.horizontal;

  return jsxs(Component$1, _objectSpread(_objectSpread({
    role: "group",
    "aria-label": "Photo album"
  }, containerProps), {}, {
    variables: _objectSpread({
      spacing: spacing,
      padding: padding,
      containerWidth: containerWidth
    }, variables),
    classes: ["", layout],
    render: container,
    ref: ref,
    children: [spacing !== void 0 && padding !== void 0 && containerWidth !== void 0 && (tracks === null || tracks === void 0 ? void 0 : tracks.map(function (_ref7, trackIndex) {
      var photos = _ref7.photos,
          trackVariables = _ref7.variables;
      var trackSize = photos.length;
      var photosCount = horizontal ? trackSize : tracks.length;
      return createElement(Component$1, _objectSpread(_objectSpread({}, trackProps), {}, {
        key: trackIndex,
        render: track,
        classes: "track",
        variables: _objectSpread({
          trackSize: trackSize
        }, trackVariables)
      }), photos.map(function (context) {
        var _photo$key;

        var photo = context.photo,
            index = context.index,
            width = context.width;
        var onClick = onClickCallback ? function (event) {
          onClickCallback({
            event: event,
            photo: photo,
            index: index
          });
        } : void 0;

        if (renderPhoto) {
          var rendered = renderPhoto({
            onClick: onClick
          }, context);
          if (rendered) return rendered;
        }

        var ariaLabel = function ariaLabel(props) {
          return photo.label ? _objectSpread({
            "aria-label": photo.label
          }, props) : props;
        };

        return jsx(PhotoComponent$1, _objectSpread({
          onClick: onClick,
          render: restRender,
          componentsProps: {
            image: _objectSpread(_objectSpread({
              loading: "lazy",
              decoding: "async"
            }, srcSetAndSizes(photo, sizes, width, containerWidth, photosCount, spacing, padding)), unwrap(imageProps, context)),
            link: ariaLabel(unwrap(linkProps, context)),
            button: ariaLabel(unwrap(buttonProps, context)),
            wrapper: unwrap(wrapperProps, context)
          }
        }, context), (_photo$key = photo.key) !== null && _photo$key !== void 0 ? _photo$key : photo.src);
      }));
    })), containerWidth === void 0 && skeleton]
  }));
}

var StaticPhotoAlbum$1 = forwardRef(StaticPhotoAlbum);
export { StaticPhotoAlbum$1 as default };